import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import { selectorButtonCss, selectorButtonSelectedCss, } from './utils/selectorButtonStyles.js';
const inspectedPathKeyCss = css({
    '&:not(:last-child):after': {
        content: '" > "',
    },
});
const inspectedPathKeyLinkCss = (theme) => ({
    cursor: 'pointer',
    color: theme.LINK_COLOR,
    '&:hover': {
        textDecoration: 'underline',
        color: theme.LINK_HOVER_COLOR,
    },
});
const ActionPreviewHeader = ({ inspectedPath, onInspectPath, tabName, onSelectTab, tabs }) => (_jsxs("div", { css: (theme) => ({
        flex: '0 0 30px',
        padding: '5px 10px',
        alignItems: 'center',
        borderBottomWidth: '1px',
        borderBottomStyle: 'solid',
        backgroundColor: theme.HEADER_BACKGROUND_COLOR,
        borderBottomColor: theme.HEADER_BORDER_COLOR,
    }), children: [_jsx("div", { css: { position: 'relative', display: 'inline-flex', float: 'right' }, children: tabs.map((tab) => (_jsx("div", { onClick: () => onSelectTab(tab.name), css: [
                    selectorButtonCss,
                    tab.name === tabName && selectorButtonSelectedCss,
                ], children: tab.name }, tab.name))) }), _jsxs("div", { css: { padding: '6px 0' }, children: [inspectedPath.length ? (_jsx("span", { css: inspectedPathKeyCss, children: _jsx("a", { onClick: () => onInspectPath([]), css: inspectedPathKeyLinkCss, children: tabName }) })) : (tabName), inspectedPath.map((key, idx) => idx === inspectedPath.length - 1 ? (_jsx("span", { children: key }, key)) : (_jsx("span", { css: inspectedPathKeyCss, children: _jsx("a", { onClick: () => onInspectPath(inspectedPath.slice(0, idx + 1)), css: inspectedPathKeyLinkCss, children: key }) }, key)))] })] }, "previewHeader"));
export default ActionPreviewHeader;
